import DefaultPage from '@components/defaultPage';
import Title from '@components/title';
import { useTranslator } from '@i18n';
import EmailSettings from '@routes/profile/settings/-emailSettings';
import PasswordSettings from '@routes/profile/settings/-passwordSettings';
import PersonalInformation from '@routes/profile/settings/-personalInformation';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/profile/settings/')({
  component: SettingsPage,
});

function SettingsPage() {
  const t = useTranslator();

  return (
    <Title title={t('settings.title')}>
      <DefaultPage
        title={t('settings.title')}
        backButton={{ to: '/profile' }}
        css={{
          display: 'grid',
          gap: 'var(--mantine-spacing-md)',
          paddingBottom: 50,

          h2: {
            marginTop: 'var(--mantine-spacing-lg)',
            paddingBottom: 'var(--mantine-spacing-xs)',
            borderBottom: '1px solid var(--mantine-color-gray-4)',
          },
        }}
      >
        <PersonalInformation />
        <EmailSettings />
        <PasswordSettings />
      </DefaultPage>
    </Title>
  );
}
